export default {
  C000000: '#000000',
  CFF453A: '#FF453A',
  CFF453A30: '#FF453A30',
  C46B721: '#46B721',
  CFFFFFF: '#FFFFFF',
};
